import React, { FC } from 'react';

import iconPurple from 'utils/icons/my-team/icon-purple.svg';
import iconCheck from 'utils/icons/my-team/check.svg';
import iconDoubleCheck from 'utils/icons/my-team/double-check.svg';

export const RightCard: FC<{
  activeCounter?: string;
  availablePlans?: string;
  hasClub?: boolean;
}> = ({ activeCounter = 0, hasClub, availablePlans = 0 }) => {
  const hasActive = +activeCounter > 0;
  const isActivePlural = activeCounter !== 1;

  const contentText = hasClub
    ? 'Gerencie os planos da sua equipe no Clube Smiles para Empresas.'
    : 'Conheça o benefício corporativo da maior empresa aérea do Brasil. Com ele, a sua equipe junta milhas todo mês e tem acesso a benefícios exclusivos, como descontos em toda plataforma Smiles.';

  const activeCounterText = `${activeCounter} pessoa${isActivePlural ? 's' : ''}`;

  let buttonText = hasClub ? 'Cadastrar equipe' : 'Conhecer Clube Smiles';

  buttonText = hasActive ? 'Acessar' : buttonText;

  return (
    <div className="my-team__container__card">
      <img className="my-team__container__card__icon" src={iconPurple} alt="" />
      <h3 className="my-team__container__card__title">Clube Smiles para Empresas</h3>
      <p className="my-team__container__card__text">{contentText}</p>
      {hasClub && (
        <>
          <p className="my-team__container__card__text">
            <img src={iconCheck} alt="" /> <strong>Planos disponíveis para:</strong>{' '}
            <span>{availablePlans} pessoas</span>
          </p>
          <p className="my-team__container__card__text">
            <img src={iconDoubleCheck} alt="" /> <strong>Planos ativos por:</strong> <span>{activeCounterText}</span>
          </p>
        </>
      )}
      <div className="my-team__container__card__button">
        <a className="my-team__container__card__button-link" href="/clube-corporativo" title="Clube Smiles">
          {buttonText}
        </a>
      </div>
    </div>
  );
};

RightCard.defaultProps = { activeCounter: '0', availablePlans: '0', hasClub: false };

export default RightCard;
